import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import WPSResource from '../../../WPS.resource';
import { ROOT_REDUCER_KEYS, GLOBAL_ACTION_KEYS } from '../../workspaceSettingsReducer';
export const defaultReducerState = getDefaultAsyncWrapperObj();
const workspaceUAAAccessGetPrefix = 'WorkspaceUAAAccessGet';
const workspaceUAAAccessGetEpicReducerArg = {
    actionPrefix: workspaceUAAAccessGetPrefix,
    reduxKeyNested: (inputPayload) => [
        ROOT_REDUCER_KEYS.GLOBAL,
        GLOBAL_ACTION_KEYS.GET_UAA_ACCESS,
    ],
    loadResource: (request) => {
        return WPSResource.getUAAAccess(request.workspaceId);
    },
    onCompleteSuccess: (resourcesResult) => resourcesResult,
};
export const uaaAccessGetEpicReducer = loadResourcesUtils(workspaceUAAAccessGetEpicReducerArg);

//# sourceMappingURL=GetUAAAccess.ducks.js.map
